module.exports = __webpack_public_path__ + "static/media/Redo.ee7623f8.svg";